import { Container } from "react-bootstrap";

export default Container;
